<template>
  <base-cell
    class="client-cell"
    condensed
    @click="onClick"
  >
    <template v-if="selectable">
      <base-icon
        class="mx-3"
        :icon="checkedIds.includes(value.pk) ? 'checked': 'unchecked'"
      />
    </template>
    <base-avatar
      v-if="item.profile_pic"
      :size="44"
      inverse
      :img="item.profile_pic"
    />
    <base-avatar
      v-else
      :size="44"
      :username="`${ item.first_name } ${ item.last_name }`"
      :img="item.first_name ? null : '/img/person.png'"
    />

    <div class="d-flex justify-content-center flex-column position-relative client-cell__fullname">
      <base-text
        v-if="isIPad"
        class="ml-4 client-cell__name client-cell-name"
        :class="isIPad ? 'cell-ipad' : '' "
        trim
      >
        {{ item.display_name_array[0] }}
      </base-text>
      <base-text
        v-else
        class="ml-4 client-cell__name client-cell-name"
        trim
      >
        {{ item.display_name_array[0] }}
      </base-text>
      <base-text
        class="ml-4 client-cell__email client-cell-email"
        size="s"
      >
        {{ item.display_name_array[1] }}
      </base-text>
    </div>

    <base-text v-if="item.unsubscribed && !isIPad" class="client-cell__unsubc">
      <span class="quill-hashtag">Opted-out of all</span>
    </base-text>

    <div class="client-cell__products">
      <base-text v-if="item.unsubscribed && isIPad" class="client-cell__unsubcipad">
        <span class="quill-hashtag">Opted-out of all</span>
      </base-text>
      <template v-if="item.cart && isIntegrated && !isIPad">
        <product
          v-for="product in products(item)"
          :key="product.url"
          :thumbnail="product.thumb"
          thumbnail-size="xsmall"
          :name="getProductName(product)"
          :price="product.formatted_price"
          :size="product.size_info"
          :last-update="(item.cart.last_update)? item.cart.last_update: item.cart.created"
          @click="productClicked(product.url)"
        />
      </template>
    </div>
    <base-icon
      v-if="!hideArrow"
      class="mr-2 ml-5"
      icon="right-arrow-cell"
    />
  </base-cell>
</template>

<script>
import utilsMixin from '@/_utilities/utilsMixin';
import responsive from '@/components/mixins/responsive';
import whichbrowser from '@/components/mixins/whichbrowser';
import integrable from '@/components/mixins/integrable';

export default {
  name: 'ClientCell',
  mixins: [whichbrowser, integrable, responsive, utilsMixin],
  model: {
    prop: 'checked',
    event: 'input',
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    hideProducts: {
      type: Boolean,
      default: false,
    },
    hideArrow: {
      type: Boolean,
      default: false,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {},

    },
    checked: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selected: false,
      bkgdColor: '#D4D4D4',
    };
  },
  computed: {
    externalIdOnly() {
      return this.useFeature('customer_external_id_only');
    },
    queryParamss() {
      return this.queryParams;
    },
    checkedIds() {
      return this.checked.map((client) => client.pk);
    },
  },
  methods: {
    products(item) {
      if (!item.cart) {
        return [];
      }

      const productLengthLimit = this.responsive.lg ? 6 : 3;

      return item.cart.products.slice(0, productLengthLimit);
    },
    longName(name) {
      if (name.length > 30) {
        return `${name.substring(0, 46)}...`;
      }
      return name;
    },
    onClick() {
      if (this.selectable) {
        this.$emit('click', this);
      } else {
        this.$emit('click', this.item);
      }
    },
    select() {
      if (this.checkedIds.includes(this.value.pk)) {
        this.checked.splice(this.checkedIds.indexOf(this.value.pk), 1);
      } else {
        this.checked.push(this.value);
      }
    },
    productClicked(productUrl) {
      this.$mixpanel.track('product_clicked', {
        account_id: this.$store.state.account.user.user.email,
        location: '/clients',
        url: productUrl,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.client-cell {
  min-height: 72px;
  padding-left: 12px !important;
  padding-right: 12px !important;
  background-color: inherit !important;
  .base-avatar {
    margin-right: 12px !important;
  }
  &__name {
    width: 419px;
    margin-left: 12px !important;
    margin-right: 12px !important;
    @media (min-width: map-get($breakpoints,'md')) {
      min-width: 200px;
    }
    @media only screen and (max-width: 828px){
      width: 375px !important;
    }
  }
  &__fullname{
    font-weight: 500;
    font-size: 14px;
    color: #1B1B1B;

  }
  &__email {
    font-size: 14px;
    font-family: 'SilkaLight';
    margin-left: 12px !important;
    margin-right: 12px !important;

  }
  &__products {
    min-height: 50px;
    margin-left: auto;
    &::v-deep .activity__img{
      margin-right: 1px;
    }
  }
  &__sep {
    border-top: solid 0.25px white;
    margin: 0.3rem 0;
    &.is-chrome {
      box-shadow: 0 -0.25px 0 white;
      min-height: 1px;
      border: none;
    }
  }
  &__unsubc {
    // margin-left:3%;
    margin-bottom: 15px;
  }
  &__unsubcipad {
    margin-top: 12px;
  }
  ::v-deep .quill-hashtag {
    max-width: 130px !important;
    width: 100% !important;
    padding: 2px 7px;
    background-color: #F0F0F0 !important;
    font-family: 'SilkaLight';
    font-weight: 400;
    font-size: 14px;
    text-transform: none;
    color: #767676 !important;
    margin-left: 12px;
    margin-right: 12px;
  }
}
.cell-ipad{
  @media (max-width: 830px) {
    width: 362px !important;
  }
}
hr {
  margin: 0.2rem 0;
  border-color: rgba(white, 0.2);
}
</style>
